export { callRpcBrowser } from "@/rpc";
